import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5d4a86bb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "detail"
};
const _hoisted_2 = {
  class: "detail-item"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, "收费规则详情", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "规则编码", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "费用类型", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "封顶金额", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "免费时长", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "计入费用时长", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "收费时间", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cell-item"
}, "每次费用", -1));
const _hoisted_11 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_descriptions, {
    column: 2,
    border: "",
    style: {
      "margin-top": "10px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_4]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.data.code), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_5]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.data.feeType), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_6]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.data.maxFee), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_7]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.data.freeDuration) + "分钟 ", 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_8]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.data.freeFee ? '计入' : '不计入'), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, null, {
      label: _withCtx(() => [_hoisted_9]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.data.beginTime) + " - " + _toDisplayString($data.data.endTime), 1)]),
      _: 1
    }), $data.data.feeType === '按次收费' ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
      key: 0
    }, {
      label: _withCtx(() => [_hoisted_10]),
      default: _withCtx(() => [_createTextVNode(" " + _toDisplayString($data.data.timesFee), 1)]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  })]), $data.data.feeType === '按时收费' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_divider, {
    "content-position": "left"
  }, {
    default: _withCtx(() => [_createTextVNode("按时收费规则明细")]),
    _: 1
  }), _createVNode(_component_el_table, {
    data: $data.data.items,
    border: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table_column, {
      label: "序号",
      width: "70px",
      prop: "seq"
    }), _createVNode(_component_el_table_column, {
      label: "计费时长",
      prop: "duration"
    }), _createVNode(_component_el_table_column, {
      label: "计费金额",
      prop: "fee"
    })]),
    _: 1
  }, 8, ["data"])])) : _createCommentVNode("", true)])), [[_directive_loading, $data.loading]]);
}